@if ((corporateTaxEntity$ | async)) {
  <form (change)="saveForm()" [formGroup]="dividendsFg">
    <div formArrayName="dividenden">
      @for (item of dividenden.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row mb-0.5">
          <div class="col-auto">
            <snelstart-ui-date-form-control (change)="this.saveForm()"
                                            [label]="i === 0 ? 'Datum uitkering' : ''"
                                            class="custom-input-150"
                                            formControlName="datumUitkering"
                                            id="datumUitkering"
                                            placeholder="dd-mm-jjjj"
            >
            </snelstart-ui-date-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-date-form-control (change)="this.saveForm()"
                                            [label]="i === 0 ? 'Datum aangifte' : ''"
                                            class="custom-input-150"
                                            formControlName="datumAangifteDividendbelasting"
                                            id="datumAangifteDividendbelasting"
                                            placeholder="dd-mm-jjjj"
            >
            </snelstart-ui-date-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control (change)="this.saveForm()"
                                              [label]="i === 0 ? 'Bruto dividend' : ''"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150" formControlName="bedragDividenduitkering"
                                              id="bedragDividenduitkering"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control (change)="this.saveForm()"
                                              [label]="i === 0 ? 'Ingehouden belasting' : ''"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="ingehoudenDividendbelasting"
                                              id="ingehoudenDividendbelasting"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'firstrowbutton' : ''"
              icon="trash"
              iconType="light"
              id="buttonDelete"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancel"
                       type="link">Dividend toevoegen
  </snelstart-ui-button>
}
